module.exports = __webpack_public_path__ + "static/media/mausam - warm night.5ac9ebb7.png";